<template>
  <div class="color-picker-wrapper" v-click-outside="onHide">
    <div ref="colorPickerIcon" class="color-picker-icon" v-bind:class="{ transparent: !color }" v-on:click="onShow" :style="{backgroundColor: color || 'transparent', borderColor: color !== '#ffffff' ? color : '#ccc'}"></div>
    <chrome-picker ref="chromePicker" v-if="showColorPicker" @input="onInputChange" :value="color" />
    <div ref="resetBtn" v-if="showColorPicker" class="btn btn-default btn-sm text-sm btn-reset" v-on:click="onReset"><i class="fas fa-xs fa-undo"/> reset to default</div>
  </div>
</template>

<script>
  import { Chrome } from "vue-color";

  export default {
    props: {
      onChange: {
        type: Function,
        default: function() {
          return;
        }
      },
      value: {
        type: String
      }
    },

    components: {
      'chrome-picker': Chrome
    },

    data: function() {
      return {
        showColorPicker: false,
        initColor: this.value || '',
        color: this.value || ''
      }
    },

    mounted() {
      window.addEventListener('scroll', this.handleScroll);
    },

    beforeDestroy() {
      window.removeEventListener('scroll', this.handleScroll);
    },

    methods: {
      handleScroll: function() {
        this.hideColorPicker();
      },
      hideColorPicker: function(){
        this.showColorPicker = false;
      },
      onShowColorPicker: function(){
        this.showColorPicker = true;
      },
      onInputChange: function(value) {
        if (value === '') this.color = ''
        else if (value && value.hex !== this.color) this.color = value.hex;
      },
      onReset: function() {
        this.color = '';
      },

      onSave: function() {
        if(this.color !== this.initColor || this.color === '' && this.value !== null)
          this.onChange(this.color)
      },

      onShow: function() {
        setTimeout(function() {
          //this.showColorPicker = true;
          this.onShowColorPicker();
          this.$nextTick(function() {
            this.setPosition();
          })
        }.bind(this), 10);
        //this.showColorPicker = true;
      },

      onHide: function() {
        if(this.showColorPicker) {
          this.hideColorPicker();
          this.onSave();
        }
      },
      setPosition: function() {
        const child = this.$refs.chromePicker.$el;
        const relative = this.$refs.colorPickerIcon;
        const resetBtn = this.$refs.resetBtn;

        const offset = {
          top: -40,
          left: 10,
          reset: -64
        }

        const { top, left, right, bottom, width, height } = relative.getBoundingClientRect();
        child.style.top = (top + offset.top) + 'px';
        child.style.left = (left + width + offset.left) + 'px';

        // Check if it is outside the window.
        const childBounds = child.getBoundingClientRect();
        const windowOffset = 10;
        
        if (childBounds.bottom - offset.reset >= (window.innerHeight || document.documentElement.clientHeight) - windowOffset) {
          const diff = childBounds.bottom - offset.reset - (window.innerHeight || document.documentElement.clientHeight);
          child.style.top = (childBounds.top - diff - windowOffset) + 'px';
        }

        if (childBounds.right >= (window.innerWidth || document.documentElement.clientWidth) - windowOffset) {
          child.style.left = (left - childBounds.width - offset.left) + 'px';
        }

        resetBtn.style.left = child.style.left;
        resetBtn.style.top = (parseInt(child.style.top, 10) || 0) + 256 + 'px';
      },
    }
  }
</script>

<style lang="scss" scoped>
  .color-picker-wrapper {
    position:relative;
    .color-picker-icon {
      height: 13px;
      width: 13px;
      display: block;
      background: #fff;
      border: 1px solid #ccc;
      border-radius: 4px;
      cursor: pointer;

      &.transparent {
        background: linear-gradient(135deg,#fff,#fff 45%,#e04728 0,#e04728 55%,#fff 0,#fff)!important;
      }
    }

    .vc-chrome{
      position: fixed;
      z-index: 2;
    }
    .btn-reset {
      position: fixed;
      z-index: 2000;
      width: 225px;
    }
  }
</style>